exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".job-wrapper[data-v-2a4fba8a]{background:#efecec}.sticky-footer .tab-pane[data-v-2a4fba8a]{padding:15px}.sticky-footer .tab-pane[data-v-2a4fba8a] .form-body{overflow-y:scroll;height:calc(var(--window-height, 100vh) - 273px)}@media (min-width:768px){.sticky-footer .tab-pane[data-v-2a4fba8a] .form-body{height:calc(var(--window-height, 100vh) - 322px)}}.job-title[data-v-2a4fba8a]{margin-top:.5rem}@media (max-width:767.98px){.job-title[data-v-2a4fba8a]{margin-top:0;font-size:1rem;font-weight:700;margin-bottom:0}}", ""]);

// exports
